import { Box } from '@mui/material';
import { useTour } from '../../../contexts/TourContext';
import { FONT, TOUR_BAR_H, tourPalette } from '../tourTheme';
import { TourButton } from './TourPrimitives';
import { TOUR_Z } from '../tourZIndex';

// Replaces the product header while a tour step is standing on a real page, so
// the surface still reads as "the tour", not the app you haven't learnt yet.
const TourAppBar = () => {
  const { active, phase, current, backToTour, completeStep, stop } = useTour();
  if (!active || phase !== 'page' || !current) return null;
  const p = tourPalette(true);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: TOUR_BAR_H,
        zIndex: TOUR_Z.tip,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { xs: '8px', sm: '16px' },
        px: { xs: '12px', sm: '24px' },
        background: p.panel,
        color: p.fg,
        borderBottom: `1px solid ${p.line}`
      }}
    >
      {/* On phones the three keys need the room: the wordmark drops to the
          page name alone, and "Skip the tour" moves into the tour itself.
          Everything here used to sit on one line and overlap. */}
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '10px', minWidth: 0, overflow: 'hidden' }}>
        {/* No hand-drawn mark: same wordmark treatment as the tour's top bar,
            so the two bars read as one piece of chrome. */}
        <Box sx={{ font: `600 14px/1 ${FONT.display}`, whiteSpace: 'nowrap', display: { xs: 'none', sm: 'block' } }}>Welcome tour</Box>
        <Box
          sx={{
            font: `500 11px/1.2 ${FONT.mono}`,
            letterSpacing: '.1em',
            opacity: 0.55,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
            ·{' '}
          </Box>
          {current.tipTitle?.toUpperCase()}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '4px', sm: '10px' }, flexShrink: 0 }}>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <TourButton p={p} variant="ghost" size="sm" onClick={() => stop('appbar')}>
            Skip the tour
          </TourButton>
        </Box>
        <TourButton p={p} variant="ghost" size="sm" onClick={backToTour}>
          <span aria-hidden>←</span>
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
            &nbsp;Back to tour
          </Box>
          <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
            &nbsp;Tour
          </Box>
        </TourButton>
        <TourButton p={p} size="sm" onClick={completeStep}>
          {current.cta}
        </TourButton>
      </Box>
    </Box>
  );
};

export default TourAppBar;
